export function isOtherProjectStatus(value) {
  return String(value || '').trim().toLowerCase() === 'other';
}

/** Custom label is only for Other. Other statuses always use the selected title. */
export function resolveProjectPhaseLabel(project = {}) {
  const statusTitle = String(project.projectstatus?.title || '').trim();
  const custom = String(project.customStatusLabel || '').trim();
  if (isOtherProjectStatus(statusTitle) && custom) return custom;
  return statusTitle;
}
